import type { CorridorOpportunity } from '~/types/corridorOpportunity';

const DEFAULT_LEAD_DAYS = 42;
const DEFAULT_NIGHTS = 7;

// Opportunities are AU-origin, so "today" is the Sydney calendar day
export function todayDate(now: Date = new Date()): string {
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'Australia/Sydney' }).format(now);
}

function addDays(date: string, days: number): string {
  const value = new Date(`${date}T00:00:00.000Z`);
  value.setUTCDate(value.getUTCDate() + days);
  return value.toISOString().slice(0, 10);
}

function upcoming(departureDate: string | null | undefined, returnDate: string | null | undefined, today: string) {
  return departureDate && returnDate && departureDate >= today && returnDate >= departureDate
    ? { departureDate: departureDate.slice(0, 10), returnDate: returnDate.slice(0, 10) }
    : null;
}

// Starting dates for the review dialog: the checked fare, else the suggestion, else six weeks out for a week
export function defaultReviewDates(opportunity: CorridorOpportunity, now: Date = new Date()) {
  const today = todayDate(now);
  const departureDate = addDays(today, DEFAULT_LEAD_DAYS);
  return (
    upcoming(opportunity.priceValidation?.departureDate, opportunity.priceValidation?.returnDate, today) ??
    upcoming(opportunity.suggestedTravel.departureDate, opportunity.suggestedTravel.returnDate, today) ?? {
      departureDate,
      returnDate: addDays(departureDate, DEFAULT_NIGHTS),
    }
  );
}
